export const GET_CHANNELS = `
query($profileId: ID, $status: String, $start: Int, $limit: Int) {
  getChatChannels(
    profileId: $profileId
    status: $status
    start: $start
    limit: $limit
  ) {
    id
    lastMessage {
      message
      user {
        id
      }
    }
    offers {
      id
      bountyId {
        bountyType
        fullName
        company
      }
      introPerson {
        id
        firstName
        lastName
      }
      channelId {
        id
        unread {
          id
        }
      }
    }
  }
}
`;


export const CHAT_COUNT = `
query($profileId: ID, $status: String) {
  chatCount(profileId: $profileId, status: $status) {
    count
  }
}
`;


export const CHAT_UNREAD_COUNT = `
query($profileId: ID) {
  channelsConnection(where: { unread: $profileId }) {
    aggregate {
      count
    }
  }
}
`;
